/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerBranchOfficeDto } from '../../models/customer-branch-office-dto';
import { CustomerBranchOfficeFormDto } from '../../models/customer-branch-office-form-dto';

export interface CreateCustomerBranchOffice$Params {

/**
 * customer id
 */
  customerId: number;
      body: CustomerBranchOfficeFormDto
}

export function createCustomerBranchOffice(http: HttpClient, rootUrl: string, params: CreateCustomerBranchOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerBranchOfficeDto>> {
  const rb = new RequestBuilder(rootUrl, createCustomerBranchOffice.PATH, 'post');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerBranchOfficeDto>;
    })
  );
}

createCustomerBranchOffice.PATH = '/customers/{customerId}/branch-offices';
